import { render, staticRenderFns } from "./SidebarCard.ts.vue?vue&type=template&id=2b7648c5"
import script from "./SidebarCard.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarCard.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SidebarCard.ts.vue?vue&type=style&index=0&id=2b7648c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports